/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        benefitsList: {
            display: 'flex',
            justifyContent: {base: 'space-around', md: 'flex-start'},
            flexWrap: 'wrap',
            color: props.hasLightBg ? 'black' : 'white',
            paddingLeft: 0
        },
        benefitsListItem: {
            color: props.hasLightBg ? 'black' : 'white',
            backgroundRepeat: 'noRepeat',
            width: '104px',
            height: '104px',
            margin: {base: '0 2rem 1rem 2rem', md: '0 1rem 0 0'},
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        }
    }),
    parts: ['benefitsList', 'benefitsListItem']
}
